
  (function () {
    // Default offer used for the immediate first paint, before window.GBS
    // is defined and before the customer's actual province is resolved.
    // Mirrors the Ontario row in window.GBS.provinceShippingOffers — keep
    // these two in sync if the rate table ever changes for Ontario.
    var DEFAULT_OFFER = {
      fixed: 10, reducedThreshold: 99, reduced: 5,
      freeThreshold: 149, transitMin: 1, transitMax: 4
    };
    var DEFAULT_PROVINCE = 'Ontario';

    function init() {
      // The snippet may render multiple times on a single page (e.g. once
      // on the PDP, once inside the cart drawer). querySelectorAll catches
      // every instance, and the data-sp-initialized guard below stops us
      // from re-wiring the same root if a second copy of this script runs.
      var roots = document.querySelectorAll('[data-shipping-progress]');
      if (!roots.length) return;
      Array.prototype.forEach.call(roots, initRoot);
    }

    function initRoot(root) {
      // Idempotent: if a previous script copy already wired this root,
      // skip it. Each root keeps its own independent state in the
      // closure created by initRoot.
      if (root.dataset.spInitialized === 'true') return;
      root.dataset.spInitialized = 'true';

      var els = {
        headline: root.querySelector('[data-sp-headline]'),
        msgFirst: root.querySelector('[data-sp-msg-first]'),
        msgSecond: root.querySelector('[data-sp-msg-second]'),
        fill: root.querySelector('[data-sp-fill]'),
        dotStart: root.querySelector('[data-sp-dot-start]'),
        dotReduced: root.querySelector('[data-sp-dot-reduced]'),
        dotFree: root.querySelector('[data-sp-dot-free]')
      };

      // Show the dollar countdown only when the customer is within this many
      // dollars of the next threshold. Below that, show a generic nudge instead
      // of a discouraging large number.
      var COUNTDOWN_PROXIMITY = 75;

      // Gradient colour stops, sampled to colour each dot to match its
      // position on the bar's fill. Keep these in sync with the CSS
      // --gbs-sp-fill-start / --gbs-sp-fill-end values.
      var GRADIENT_START = { r: 0x1d, g: 0x6f, b: 0xb8 }; // #1d6fb8
      var GRADIENT_END   = { r: 0x00, g: 0xa8, b: 0xe8 }; // #00a8e8

      function sampleGradient(ratio) {
        var t = Math.max(0, Math.min(1, ratio));
        var r = Math.round(GRADIENT_START.r + (GRADIENT_END.r - GRADIENT_START.r) * t);
        var g = Math.round(GRADIENT_START.g + (GRADIENT_END.g - GRADIENT_START.g) * t);
        var b = Math.round(GRADIENT_START.b + (GRADIENT_END.b - GRADIENT_START.b) * t);
        return 'rgb(' + r + ', ' + g + ', ' + b + ')';
      }

      // Minimum visual fill so the bar always reads as "started" rather than
      // empty. Compresses the journey from MIN_FILL_PCT-100% rather than
      // clamping at the bottom — keeps the fill linear and continuous.
      var MIN_FILL_PCT = 10;

      var cartTotalCents = 0;

      // Resolve province + offer with graceful fallback. Before window.GBS
      // is ready, both come from the local DEFAULT_* constants so the bar
      // can paint immediately. Once GBS is ready, we use the real values.
      function currentProvince() {
        if (window.GBS && typeof window.GBS.getOverrideProvince === 'function') {
          return window.GBS.currentProvince || window.GBS.defaultProvince || DEFAULT_PROVINCE;
        }
        return DEFAULT_PROVINCE;
      }

      function currentOffer(province) {
        if (window.GBS && typeof window.GBS.getProvinceOffer === 'function') {
          return window.GBS.getProvinceOffer(province);
        }
        return DEFAULT_OFFER;
      }

      function render() {
        var province = currentProvince();
        var offer = currentOffer(province);

        if (!offer) {
          root.hidden = true;
          return;
        }

        var transitText = offer.transitMin + '\u2013' + offer.transitMax + ' business days';

        // Territory — shipping calculated downstream. Reuse msgFirst as a
        // single full-width subtext line so customers know what happens
        // at checkout. No milestones (no thresholds to mark).
        if (offer.calculatedAtCheckout) {
          root.setAttribute('data-sp-state', 'territory');
          els.headline.innerHTML = 'Shipping calculated at checkout for <strong>' + province + '</strong>';
          els.msgFirst.textContent = 'We\u2019ll show the available shipping options before you pay.';
          els.msgSecond.textContent = '';
          els.fill.style.width = '0%';
          els.dotStart.style.display = 'none';
          els.dotReduced.style.display = 'none';
          els.dotFree.style.display = 'none';
          els.msgFirst.style.flex = '1 1 100%';
          els.msgSecond.style.flex = '0 0 0';
          root.hidden = false;
          return;
        }

        els.dotStart.style.display = '';
        els.dotReduced.style.display = '';
        els.dotFree.style.display = '';

        // Position the reduced dot using the SAME scale the fill uses.
        // Without MIN_FILL_PCT, this would be reducedThreshold/freeThreshold.
        // With it, $0 maps to MIN_FILL_PCT and free maps to 100%, so the dot
        // must sit on that compressed scale or the fill won't land on it
        // at the threshold moment.
        var reducedRatio = offer.reducedThreshold / offer.freeThreshold;
        var reducedBarPos = MIN_FILL_PCT + reducedRatio * (100 - MIN_FILL_PCT);
        els.dotReduced.style.left = reducedBarPos + '%';

        var subtotal = cartTotalCents / 100;
        var minimum = (offer.minimumOrder && offer.minimumOrder > 0) ? offer.minimumOrder : 0;
        var hasMinimum = minimum > 0;
        var belowMinimum = hasMinimum && subtotal < minimum;
        var reducedReached = subtotal >= offer.reducedThreshold;
        var freeReached = subtotal >= offer.freeThreshold;

        if (belowMinimum) {
          // State A — cart below province minimum. Keep the normal
          // rate-based headline (same as every other province) and let the
          // blue subtext carry the minimum-order explanation. The headline
          // is set below in the shared block, so here we only set the
          // subtext and collapse the second zone.
          root.setAttribute('data-sp-state', 'below-minimum');
          var belowRate;
          if (offer.fixed === 0) {
            belowRate = '<strong>FREE</strong> standard shipping';
          } else {
            belowRate = '<strong>$' + offer.fixed + '</strong> standard shipping';
          }
          els.headline.innerHTML =
            belowRate +
            ' to <strong>' + province + '</strong> ' +
            '<strong>' + transitText + '</strong>';
          els.msgFirst.textContent = 'Minimum order for shipping is $' + minimum + '. Add a few more favourites to continue.';
          els.msgSecond.textContent = '';
          els.msgFirst.style.flex = '1 1 100%';
          els.msgSecond.style.flex = '0 0 0';
        } else {
          // States B–H — original rate-based headline + two-zone messaging.
          // Message zones still use the compressed scale so they stay
          // centered beneath their segments. First zone is from 0 to
          // reducedBarPos, second zone is from reducedBarPos to 100.
          els.msgFirst.style.flex = '0 0 ' + reducedBarPos + '%';
          els.msgSecond.style.flex = '0 0 ' + (100 - reducedBarPos) + '%';

          // State attribute for mobile CSS to key off. Mirrors the band
          // logic below so CSS doesn't have to duplicate it.
          var spState = freeReached ? 'free-reached'
                      : reducedReached ? 'reduced-reached'
                      : 'pre-reduced';
          root.setAttribute('data-sp-state', spState);

          // Headline (Row 1): reflects the customer's CURRENT shipping rate.
          // Below reduced → fixed rate. Reduced reached → reduced rate.
          // Free reached → "FREE shipping".
          var headlineRate;
          if (freeReached) {
            headlineRate = '<strong>FREE</strong> standard shipping';
          } else if (reducedReached) {
            headlineRate = '<strong>$' + offer.reduced + '</strong> standard shipping';
          } else {
            headlineRate = '<strong>$' + offer.fixed + '</strong> standard shipping';
          }
          els.headline.innerHTML =
            headlineRate +
            ' to <strong>' + province + '</strong> ' +
            '<strong>' + transitText + '</strong>';

          // Row 3 messages (positioned beneath their respective bar segments):
          //
          // First zone (start → reduced):
          //   Below proximity:    "Add more to unlock discounted shipping"
          //   Within proximity:   "$X away from $N shipping"
          //   Reduced reached:    "$N shipping unlocked"
          //   Free reached:       "$N shipping unlocked"
          //
          // Second zone (reduced → free):
          //   Reduced not reached: empty (no marker yet)
          //   Reduced reached:     "$X away from FREE shipping"
          //   Free reached:        "FREE shipping unlocked"
          var firstMsg, secondMsg;

          if (freeReached) {
            firstMsg = '$' + offer.reduced + ' shipping unlocked';
            secondMsg = 'FREE shipping unlocked';
          } else if (reducedReached) {
            var awayFromFree = Math.ceil(offer.freeThreshold - subtotal);
            firstMsg = '$' + offer.reduced + ' shipping unlocked';
            secondMsg = '$' + awayFromFree + ' away from FREE shipping';
          } else {
            var awayFromReduced = offer.reducedThreshold - subtotal;
            if (awayFromReduced <= COUNTDOWN_PROXIMITY) {
              firstMsg = '$' + Math.ceil(awayFromReduced) + ' away from $' + offer.reduced + ' shipping';
            } else {
              firstMsg = 'Add more to unlock discounted shipping';
            }
            secondMsg = '';
          }

          els.msgFirst.textContent = firstMsg;
          els.msgSecond.textContent = secondMsg;
        }

        // Bar fill — same formula as before. Linear from $0 to free, with
        // a MIN_FILL_PCT floor so the bar reads as "started" at empty cart.
        var journeyRatio = Math.min(1, subtotal / offer.freeThreshold);
        var fillPct = MIN_FILL_PCT + journeyRatio * (100 - MIN_FILL_PCT);
        els.fill.style.width = fillPct + '%';

        // Dot reached states — colour-sample the gradient at each dot's ratio.
        els.dotStart.classList.add('gbs-shipping-progress__dot--reached');
        els.dotReduced.classList.toggle('gbs-shipping-progress__dot--reached', reducedReached);
        els.dotFree.classList.toggle('gbs-shipping-progress__dot--reached', freeReached);

        els.dotStart.style.background = sampleGradient(0);
        els.dotReduced.style.background = reducedReached ? sampleGradient(reducedRatio) : '';
        els.dotFree.style.background = freeReached ? sampleGradient(1) : '';

        root.hidden = false;
      }

      function fetchCart() {
        fetch('/cart.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            cartTotalCents = (cart && cart.total_price) || 0;
            render();
          })
          .catch(function () { render(); });
      }

      // Initial pass with no cart data, then async fetch.
      // First paint uses DEFAULT_OFFER if window.GBS isn't ready yet —
      // the bar appears immediately and re-renders when GBS fires its
      // first 'gbs:province-change' event (theme.liquid dispatches one
      // on init, with the IP-resolved or default province).
      render();
      fetchCart();

      // Recalculate when province changes (no cart refetch needed).
      // This event fires once on theme.liquid's init (handing us the
      // resolved province), and again on every override change.
      window.addEventListener('gbs:province-change', render);

      // Re-pull cart when tab regains focus or page becomes visible.
      window.addEventListener('focus', fetchCart);
      document.addEventListener('visibilitychange', function () {
        if (document.visibilityState === 'visible') fetchCart();
      });

      // Re-pull after any add-to-cart form submission.
      document.addEventListener('submit', function (e) {
        var form = e.target;
        if (form && form.action && form.action.indexOf('/cart/add') > -1) {
          setTimeout(fetchCart, 800);
        }
      });

      // Public hook for future cart panel rebuild to trigger a refresh.
      window.addEventListener('gbs:cart-updated', fetchCart);
    }

    // Guard against the snippet being rendered (and therefore this script
    // being parsed) more than once on a page. Each parsed copy still calls
    // initRoot per uninitialized root, but we only want one bootstrap +
    // one set of global listeners, not N.
    if (window.__gbsSpBootstrapped) return;
    window.__gbsSpBootstrapped = true;

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
